import Vue from 'vue'
import {i18n} from '@/integrations/i18n'
import {eventBus} from '@/utils/eventBus'

const state = Vue.observable({online: navigator.onLine})

let stickyToastId = null
let initialized = false

const t = key => {
  const value = i18n.t(key)
  return value === key ? '' : value
}

const showOfflineToast = () => {
  if (!Vue.$toast || stickyToastId !== null) return
  const message = t('components.offline.lostConnection') || 'You are offline'
  stickyToastId = Vue.$toast.error(message, {
    timeout: false,
    closeOnClick: false,
    closeButton: false,
    icon: false
  })
}

const dismissOfflineToast = () => {
  if (!Vue.$toast || stickyToastId === null) return
  Vue.$toast.dismiss(stickyToastId)
  stickyToastId = null
}

const showOnlineToast = () => {
  if (!Vue.$toast) return
  const message = t('components.offline.connectionRestored') || 'Connection restored'
  Vue.$toast.success(message, {timeout: 1500})
}

const apply = (value, {silent = false} = {}) => {
  if (state.online === value) return
  const wasOffline = !state.online
  state.online = value
  eventBus.$emit('connection:change', value)
  if (silent || !initialized) return
  if (!value) showOfflineToast()
  else if (wasOffline) {
    dismissOfflineToast()
    showOnlineToast()
  }
}

export const markOffline = () => apply(false)
export const markOnline = () => apply(true)
export const isOnline = () => state.online

export const offlinePlugin = {
  install(VueCtor) {
    Object.defineProperty(VueCtor.prototype, '$online', {
      get: () => state.online
    })

    window.addEventListener('online', () => apply(true))
    window.addEventListener('offline', () => apply(false))

    // Sticky toast for cold-start offline state, deferred so $toast and i18n are ready.
    Vue.nextTick(() => {
      initialized = true
      if (!state.online) showOfflineToast()
    })
  }
}

export default offlinePlugin
